import {Box, HBox} from '@buncha/components/core/view';

import {Components} from '@buncha/localization/types';
import {CustomText} from '@buncha/components/core/text';
import {Modules} from '@buncha/utils/types';
import React from 'react';
import {StyleSheet} from 'react-native';
import UploadProgressIcon from '@buncha/components/core/icon/UploadProgressIcon';
import font from '@buncha/appStyles/style/font';
import {useColorThemeType} from '@buncha/appStyles/hooks/theme';
import {useGetLocale} from '@buncha/localization/hooks';
import {useHandleAppMinimize} from '@buncha/config/fileUpload/hook';

const FileUploadHeader = () => {
  const theme = useColorThemeType();
  const {body} = useGetLocale(Modules.components, Components.components) ?? {};
  useHandleAppMinimize();
  return (
    <Box
      style={[
        styles.mainContainer,
        {
          backgroundColor: theme?.background.yellow[100],
        },
      ]}>
      <HBox style={styles.container}>
        <UploadProgressIcon
          fill={theme?.background.yellow[100]}
          viewBox="-2 -3 25 25"
          stroke={theme?.background.blue[300]}
        />
        <CustomText
          style={[
            styles.title,
            {
              color: theme?.text.blue[300],
            },
          ]}>
          {body?.uploadInProgress}
        </CustomText>
      </HBox>
    </Box>
  );
};

export default React.memo(FileUploadHeader);

const styles = StyleSheet.create({
  mainContainer: {
    flex: 1,
  },
  container: {
    justifyContent: 'flex-start',
  },
  title: {
    marginLeft: 8,
    fontFamily: font.fonts.muliSemiBold,
  },
});
